import React from "react";
import Cards from "./components/Cards"
import Home from "./pages/Home"
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Gratitude from "./components/Gratitude";


function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/gratitude" element={<Gratitude />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
